import {
    Component,
    Input
} from '@angular/core';

@Component({
    selector: 'agpr-divider-display',
    templateUrl: './divider-display.component.html',
    styleUrls: ['./divider-display.component.scss'],
    standalone: false
})
export class DividerDisplayComponent {
    @Input() data: any;
    constructor() {}
}
